import { jobCanBeDownloaded } from '@helpers/jobStatus/jobCanBeDownloaded';
import { jobCanBeResubmitted } from '@helpers/jobStatus/jobCanBeResubmitted';
import { jobCanBeShared } from '@helpers/jobStatus/jobCanBeShared';
import { jobIsEditable } from '@helpers/jobStatus/jobIsEditable';
import { JobResponseDto, MeResponseDto, MeResponseDtoOrganization } from 'app/API';

export const canShowButtonsTRow = (
  job: JobResponseDto,
  isVsAdmin: boolean,
  canManageWorkspaces: boolean,
  organization: MeResponseDtoOrganization | undefined,
  me: MeResponseDto,
) => {
  const canSubmitJobs = !!organization?.permissions?.submitJobs;
  const showMoveToWSButton = !job.asOneLocked && canSubmitJobs;
  const showDeleteButton = organization?.permissions?.deleteJobs;
  const showShareButton = jobCanBeShared(job.status);
  const showResubmitButton = isVsAdmin && jobCanBeResubmitted(job.status);
  const showEditButton = jobIsEditable(job.status);
  const showDownloadLinks =
    (me?.id === job?.assigneeId || organization?.permissions?.viewJobs === 'all') && jobCanBeDownloaded(job.status);

  if (canManageWorkspaces) {
    return true;
  }
  if (showDownloadLinks) {
    return true;
  }
  if (showMoveToWSButton) {
    return true;
  }
  if (showEditButton) {
    return true;
  }
  if (showResubmitButton) {
    return true;
  }
  if (showDeleteButton) {
    return true;
  }
  return showShareButton;
};
